exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cookie-consent{font-size:14px;color:#fff;font-family:Nunito,sans-serif;background:rgba(30,30,30,.5)}.cookie-button{background-color:#fbc531!important;text-decoration:none;color:#fff!important;padding:8px!important;border-radius:2px!important}.cookie-consent a{color:#fbc531;cursor:pointer;font-size:12px;font-weight:600;margin-left:5px;text-decoration:none}.cookie-consent a:hover{font-weight:900}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/components/Cookie/cookie.scss
// module id = 155
// module chunks = 0